import appPackage from '../../package.json'
import monorepoPackage from '../../../../package.json'

// TODO: check that all values are used

/**
 * Indicates whether NODE_ENV is production
 * @namespace Config
 */
export const isProd = import.meta.env.NODE_ENV === 'production'

export const isApiProd =
  import.meta.env.VITE_APP_API_BASE_URL === 'https://api-prod.popety.io/api/v2'

export const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL as string

/**
 * Indicates whether NODE_ENV is development
 * @namespace Config
 */
export const isDev = import.meta.env.NODE_ENV === 'development'

export const MAPBOX_TOKEN = import.meta.env.VITE_APP_MAPBOX_TOKEN as string

export const SHADEMAP_API_KEY = import.meta.env.VITE_SHADEMAP_API_KEY

export const LIGHT_MAPSTYLE = 'mapbox://styles/mapbox/light-v10'

export const SWITZERLAND_GEO_CENTER = [8.304620661, 46.813258144] as [
  number,
  number,
]

export const GOOGLE_MAP_TOKEN = import.meta.env
  .VITE_GOOGLE_MAP_API_KEY as string

export const DEFAULT_PROFILE_IMG =
  'https://storage.googleapis.com/popetyio-web/user-company-logo/default.png'

export const DEFAULT_OFFICE_IMG = '/assets/img/office-icon.png'

export const ZONE_LAYOUT_MAPSTYLE =
  'mapbox://styles/popety/cl3a7v8hy001y14pejeo2af8o'

export const ZONE_SATELLITE_MAPSTYLE =
  'mapbox://styles/popety/clfi67w71001601mpthh1rl52'

export const DEFAULT_MAPSTYLE =
  'mapbox://styles/popety/cm7mg342r00u001s21uzzd25t'

export const SATELLITE_MAPSTYLE =
  'mapbox://styles/popety/cl449l1ah000414umwqgcr0pd'

export const STYLE_PREFIX = 'mapbox://styles/'

export const APP_VERSION = isApiProd
  ? appPackage.version
  : monorepoPackage.version

export const BUILD_TIME = __BUILD_TIME__

export const ESTIMATE_PURCHASE_APARTMENT =
  import.meta.env.ESTIMATE_PURCHASE_APARTMENT ||
  'estimate-purchase-apartment-v2.1'

export const ESTIMATE_PURCHASE_HOUSE =
  import.meta.env.ESTIMATE_PURCHASE_HOUSE || 'estimate-purchase-house-v2.1'

export const ESTIMATE_RENT_APARTMENT =
  import.meta.env.ESTIMATE_RENT_APARTMENT || 'estimate-rent-apartment-v2.1'

export const ESTIMATE_RENT_HOUSE =
  import.meta.env.ESTIMATE_RENT_HOUSE || 'estimate-rent-house-v2.1'

export const MIN_PRICE_PURCHASE =
  Number(import.meta.env.MIN_PRICE_PURCHASE) || 4000

export const MAX_PRICE_PURCHASE =
  Number(import.meta.env.MAX_PRICE_PURCHASE) || 19000

export const MIN_PRICE_RENT = Number(import.meta.env.MIN_PRICE_RENT) || 180

export const MAX_PRICE_RENT = Number(import.meta.env.MAX_PRICE_RENT) || 550

export const ESTIMATE_VALUE_FIELD = 'price_m2'

export const LIB_VERSION = import.meta.env.VITE_APP_LIB_VERSION || ''

export const MAX_RANKING_HEIGHT = 100

export const MAX_LUP_AVAILABLE_HEIGHT = 8

export const MAX_LUP_AVAILABLE_FLOORS = 3

export const UE_SCORE_AVAILABLE_FLOORS = 3

export const NEIGHBORS_MAX_HEIGHT_DIFF = 8

export const MAX_QUARTIER_PERCENTILE_HEIGHT = 100

export const GOOGLE_CLIENT_ID = String(
  import.meta.env.VITE_APP_GOOGLE_CLIENT_ID
)

export const livabilityDistance = 2400

let HOST_PUBLIC = !isDev
  ? import.meta.env.VITE_APP_HOST_PUBLIC ||
    'https://dev-estimate-popety-io.netlify.app'
  : 'http://localhost:3001'

if (isApiProd) {
  HOST_PUBLIC = 'https://share.popety.io'
}

export const HOST = HOST_PUBLIC

export const DOWNLOAD_LINK = {
  googleAuthenticator: {
    googlePlay:
      'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US&pli=1',
    appStore: 'https://apps.apple.com/fr/app/google-authenticator/id388497605',
  },
  microsoftAuthenticator: {
    googlePlay:
      'https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=fr',
    appStore:
      'https://apps.apple.com/us/app/microsoft-authenticator/id983156458',
  },
}

/**
 * SENTRY SETUP
 */
export const SENTRY_DNS =
  'https://86b9b57afc3e40b4b55a8ea018dcbb13@o926084.ingest.sentry.io/4504769294041088'

/**
 * App pages. key is the unique key that identify each page. It is used to load i18n by page.
 * So add it must be unique and must match the its i18n folder like i18n/language/page where
 * page is the unique key of the page. Ex: i18n/fr/home
 * @namespace Config
 */
export const PAGES = [
  { pathname: '/', key: 'search,driver' },
  { pathname: '/developer-map', key: 'search,driver' },
  { pathname: '/counter', key: 'counter,driver' },
  { pathname: '/login', key: 'login' },
  { pathname: '/account', key: 'account,driver' },
  { pathname: '/developer-map', key: 'search,driver,land-detail' },
  {
    pathname: '/land-detail/plot',
    key: 'land-detail,listingHistory,faoHistory,transactionHistory,driver,estimate,building-detail',
  },
  {
    pathname: '/land-detail/building',
    key: 'land-detail,listingHistory,faoHistory,transactionHistory,driver,estimate,building-detail',
  },
  {
    pathname: '/land-detail',
    key: 'land-detail,listingHistory,faoHistory,transactionHistory,driver,estimate',
  },
  {
    pathname: '/transaction-history',
    key: 'transactionHistory,driver,faoHistory,land-detail,listingHistory',
  },
  { pathname: '/listing-history', key: 'listingHistory,driver,land-detail' },
  { pathname: '/fao-history', key: 'faoHistory,driver,land-detail' },
  { pathname: '/help', key: 'help,driver' },
  {
    pathname: '/dashboard',
    key: 'land-detail,dashboard,driver,listingHistory',
  },
  { pathname: '/building-dashboard', key: 'dashboard,search,driver' },
  { pathname: '/sources', key: 'sources,driver' },
  { pathname: '/glossary', key: 'glossary,driver' },
  {
    pathname: '/my-alerts',
    key: 'myAlerts,listingHistory,faoHistory,transactionHistory,driver',
  },
  { pathname: '/company-dashboard', key: 'companyDashboard,driver' },
  { pathname: '/user-guide', key: 'user-guide,driver' },
  {
    pathname: '/estimate',
    key: 'land-detail,listingHistory,faoHistory,transactionHistory,driver,estimate,dashboard,search,listing,building-detail',
  },
  { pathname: '/developer-map/list', key: 'search,land-detail,driver' },
  { pathname: '/dashboard', key: 'land-detail,driver' },
] as const

export const LOCATION_TYPE = {
  ADDRESS: 'address',
  REGION: 'region',
  CITY: 'city',
  DISTRICT: 'district',
  LAND: 'land',
  NPA: 'npa',
  EGID: 'egid',
  EGRID: 'egrid',
  MUNICIPALITY: 'municipality',
} as const

export type LocationType = (typeof LOCATION_TYPE)[keyof typeof LOCATION_TYPE]

export const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const EMAIL_REGEX = /^\S+@\S+\.\S+$/

export const LANG_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'Allemand' },
]
